package dev.terrakok.mapitan.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import dev.terrakok.mapitan.ui.Icons

@Composable
fun CanvasToolbar(
    scalePercent: Int,
    canUndo: Boolean,
    canRedo: Boolean,
    onZoomOut: () -> Unit,
    onZoomIn: () -> Unit,
    onUndo: () -> Unit,
    onRedo: () -> Unit,
    onResetZoom: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        // Zoom controls
        Row(
            modifier = Modifier
                .background(
                    color = MaterialTheme.colorScheme.surfaceContainerHighest,
                    shape = MaterialTheme.shapes.small,
                ),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            IconButton(
                onClick = onZoomOut,
                modifier = Modifier.size(30.dp),
                shape = MaterialTheme.shapes.small,
            ) {
                Icon(
                    imageVector = Icons.Minus,
                    contentDescription = "Zoom out",
                    modifier = Modifier.size(16.dp),
                )
            }
            Text(
                text = "$scalePercent%",
                style = MaterialTheme.typography.bodySmall,
                fontWeight = FontWeight.Medium,
                modifier = Modifier
                    .clip(RoundedCornerShape(8.dp))
                    .clickable { onResetZoom() }
                    .padding(8.dp),
            )
            IconButton(
                onClick = onZoomIn,
                modifier = Modifier.size(30.dp),
                shape = MaterialTheme.shapes.small,
            ) {
                Icon(
                    imageVector = Icons.Plus,
                    contentDescription = "Zoom in",
                    modifier = Modifier.size(16.dp),
                )
            }
        }

        // Undo / Redo
        Row(
            modifier = Modifier
                .background(
                    color = MaterialTheme.colorScheme.surfaceContainerHighest,
                    shape = MaterialTheme.shapes.small,
                ),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            IconButton(
                onClick = onUndo,
                enabled = canUndo,
                shape = MaterialTheme.shapes.small,
                modifier = Modifier.size(30.dp),
            ) {
                Icon(
                    imageVector = Icons.Undo,
                    contentDescription = "Undo",
                    modifier = Modifier.size(16.dp),
                )
            }
            IconButton(
                onClick = onRedo,
                enabled = canRedo,
                shape = MaterialTheme.shapes.small,
                modifier = Modifier.size(30.dp),
            ) {
                Icon(
                    imageVector = Icons.Redo,
                    contentDescription = "Redo",
                    modifier = Modifier.size(16.dp),
                )
            }
        }
    }
}
